export default __webpack_public_path__ + "static/media/abstracto21440.09f27d73.jpg";